<template>
  <section class="section-wrapp">
    <StationTable></StationTable>
  </section>
</template>

<script>
import StationTable from '@/components/stations/StationTable.vue'

export default {
  name: 'Stations',
  components: {
    StationTable
  },
  data() {
    return {
      message: ''
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters['station/isLoading']
    },
    hasError() {
      return this.$store.getters['station/hasError']
    },
    error() {
      return this.$store.getters['station/error']
    },
    hasStations() {
      return this.$store.getters['station/hasPosts']
    },
    stations() {
      return this.$store.getters['station/stations']
    }
  },
  created() {
    //    this.$store.dispatch('station/findAll')
    this.$store.dispatch('station/unsetCurrent')
  },
  methods: {
    async createStation() {
      const result = await this.$store.dispatch('station/create', this.$data.message)
      if (result !== null) {
        this.$data.message = ''
      }
    },
    showStations() {
      console.log(this.stations())
    }
  }
}
</script>
